import { Outlet } from "react-router-dom";

const LayoutOutlet = () => {
  return (
    <>
      <Outlet />
    </>
  )
};

export default LayoutOutlet;